import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import CardListContext from './ListContext';
import styles from './List.module.scss';

const CardList = ({ display, columns, className, children }) => (
  <div className={cn(styles[display], className)}>
    <CardListContext.Provider value={{ display, columns }}>
      {children}
    </CardListContext.Provider>
  </div>
);

CardList.propTypes = {
  display: PropTypes.oneOf(['list', 'matrix']),
  columns: PropTypes.number,
  className: PropTypes.string,
};

CardList.defaultProps = {
  display: 'list',
  columns: 3,
  className: null,
};

export default CardList;
